<template>
  <div
    v-if="theme.sidebarMobileOpen"
    class="sidebar-backdrop"
    @click="theme.sidebarMobileOpen = false"
  ></div>
  <aside
    id="logo-sidebar"
    class="sidebar"
    :class="{
      'is-open': isOpen,
      'is-floating': isOpen && !theme.sidebarPinned,
      'is-mobile-open': theme.sidebarMobileOpen,
    }"
    aria-label="Sidebar"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <router-link to="/dashboard" class="sidebar-brand">
      <span class="brand-mark">i</span>
      <span class="sidebar-label leading-tight">
        <span class="block text-sm font-semibold text-white">i-Liliana</span>
        <span class="block text-[11px] text-blue-200/60">Panel Admin</span>
      </span>
    </router-link>

    <nav class="sidebar-nav">
      <div v-for="(group, index) in groups" :key="index">
        <div v-if="group.label" class="sidebar-group">
          <span class="sidebar-label">{{ group.label }}</span>
        </div>
        <router-link
          v-for="item in group.items"
          :key="item.path"
          :to="item.path"
          class="sidebar-link"
          :class="{ 'is-active': isActive(item) }"
          :title="isOpen ? null : item.label"
        >
          <span class="sidebar-icon">
            <font-awesome-icon :icon="['fas', item.icon]" />
          </span>
          <span class="sidebar-label">{{ item.label }}</span>
        </router-link>
      </div>
    </nav>
  </aside>
</template>

<script>
import userData from "../plugins/userData";
import { theme } from "../plugins/theme";
import { visibleGroups, isActivePath } from "../plugins/menu";

export default {
  name: "SideBar",
  mixins: [userData],
  data() {
    return {
      theme,
      isHovered: false,
    };
  },
  computed: {
    groups() {
      return visibleGroups(this.userLevel);
    },
    isOpen() {
      return this.theme.sidebarPinned || this.isHovered;
    },
  },
  watch: {
    "$route.path"() {
      this.theme.sidebarMobileOpen = false;
    },
  },
  methods: {
    isActive(item) {
      return isActivePath(item.path, this.$route.path);
    },
  },
};
</script>
